enum AdminPaths {
  ENROLLMENT_LIST_PATH = "/enrollment-list",
  DEALER_UPLOADER_PATH = "/dealer-upload",
  PRODUCT_UPLOADER_PATH = "/product-upload",
  QUIZZES_PATH = "/quizzes",
  PROGRAM_COMMUNICATIONS_PATH = "/program-communications",
  CLAIMS_PATH = "/claims",
  CLAIM_REPORT_PATH = "/claim-report",
  ENROLLMENT_REPORT_PATH = "/enrollment-report",
  CHANGE_ADDRESS_REPORT_PATH = "/change-info-report",
  ADD_INCENTIVE_PATH = "/add-incentive",
  UPDATE_INCENTIVE_PATH = "/update-incentive/:productId",
  ADD_USER_PATH = "/add-user",
  USERS_LIST_PATH = "/users",
  CLAIM_APPROVAL_PATH = "/claim-approval",
  EDIT_CLAIM_PATH = "/edit-claim",
  INVOICE_ORDER_PATH = "/invoice-order",
  ANNOUNCEMENT_PATH = "/announcements",
}

enum ConsumerPaths {
  PHYSICAL_CARD_REDEEMED= "/physicalcardredeemed",
  PHYSICAL_CARD_CONTENT= "/redeemphysicalcard",
  ENROLLMENT_FORM_PATH = "/enrollment-form",
  CLAIM_SALE_PATH = "/claim-sale",
  MY_ACCOUNT_PATH = "/my-account",
  MY_PROFILE_PATH = "/my-account/profile",
  MY_INBOX_PATH = "/my-account/inbox",
  LANDING_PATH = "/landing",
  QR_LANDING_PATH = "/qrlanding",
}

enum CommonPaths {
  HOME_PATH = "/",
  CONTACTUS_PATH = "/contactus",
  SIGNIN_PATH = "/signin",
  SIGNOUT_PATH = "/signout",
  CURRENT_INCENTIVES_PATH = "/current-incentives",
  RESOURCES_FAQ_PATH = "/resources-faq",
  RESOURCES_RULES_PATH = "/resources-program-rules",
  UPDATE_PASSWORD_PATH = "/update-password/:token",
  FORGOT_PASSWORD_PATH = "/forgot-password",
}

export { AdminPaths, ConsumerPaths, CommonPaths }
